import React from "react";
import PropTypes from "prop-types";
import {
  Divider,
  OrderedList,
  ListItem,
  Heading,
  Text,
  Box,
  Image,
} from "@chakra-ui/react";
import Card from "components/Card/Card";

const CommunityProjects = (props) => {
  return (
    <Box minWidth="960px" maxWidth="80%" mb={5} py={10}>
      <Heading as="h2" size="xl" color="rgb(140, 140, 227)" mb={3}>
        Community Projects
      </Heading>
      <Text fontSize="lg" color="white" mb={3}>
        Projects developed by the BWS community
      </Text>

      <Box display="flex" gap="20px" width="100%" py={5}>
        <Box flex="1">
          <Card>
            <Box pt={3} m={5}>
              <Text fontSize="md" color="white" fontWeight="700">
                Bounty 1
              </Text>
              <Text fontSize="xl" color="rgb(140, 140, 227)" fontWeight="700">
                Vault-as-a-Service
              </Text>
            </Box>
            <Divider />
            <Box display="flex" gap="10px">
              <Box p={5} flex="1">
                <Text fontSize="md" color="white" fontWeight="700" mb={3}>
                  BWS Plans to use third-party battle-tested
                  Vaults-as-a-Service.
                </Text>

                <OrderedList className="list">
                  <ListItem fontSize="lg" color="white" py={2}>
                    Allow us to cut time to market
                  </ListItem>
                  <ListItem fontSize="lg" color="white" py={2}>
                    Cement partnerships with best-in-class projects
                  </ListItem>
                  <ListItem fontSize="lg" color="white" py={2}>
                    Make user use already trusted and audited smart contracts
                  </ListItem>
                  <ListItem fontSize="lg" color="white" py={2}>
                    Avoid conflicts of interest to be player and referee at the
                    same time
                  </ListItem>
                </OrderedList>
              </Box>
              <Box
                play="flex"
                flexDirection="column"
                flex="1"
                justifyContent="center"
              >
                <Image
                  p={5}
                  src="./assets/beefy.png"
                  width="300px"
                  alt="Beefy"
                  margin="0 auto"
                />
                <Image
                  p={5}
                  src="./assets/dopex-ssov.png"
                  width="300px"
                  alt="SSOV"
                  margin="0 auto"
                />
              </Box>
            </Box>
          </Card>
        </Box>

        <Box flex="1">
          <Card>
            <Box pt={3} m={5}>
              <Text fontSize="md" color="white" fontWeight="700">
                Bounty 2
              </Text>
              <Text fontSize="xl" color="rgb(140, 140, 227)" fontWeight="700">
                Fair Mark-to-Market Valuation
              </Text>
            </Box>
            <Divider />
            <Box display="flex" gap="10px">
              <Box p={5} flex="1">
                <Text fontSize="lg" color="white" mb={3}>
                  BWS Guarantees user a fill at 100 on the custtom index at t+1
                  since receiving the order.
                </Text>
                <Text fontSize="lg" color="white" mb={3}>
                  The index is updated dayly at 9:30 AM EST. According to
                  Chainlink or Depex Oracle Snapshot.
                </Text>
                <Text fontSize="lg" color="white" mb={3}>
                  At the end of an epoch or when the user withdraws funds, we
                  consult Chainlink and Dopex oracle, and the user gets back his
                  fund plus-minus the resulting PNL in USDC minus withdraws fee
                  if nay.
                </Text>
                <Text fontSize="lg" color="white" mb={3}>
                  The user is guaranteed to receive 80% of what is deposited in
                  USDC + 10% rBWS token in the worst case-scenario. Best Case is
                  uncapped in USDC.
                </Text>
              </Box>

              <Box
                play="flex"
                flexDirection="column"
                flex="1"
                justifyContent="center"
              >
                <Image
                  p={5}
                  src="./assets/chainlink.png"
                  width="300px"
                  alt="Chainlink"
                  margin="0 auto"
                />
                <Image
                  p={5}
                  src="./assets/dopex-ssov.png"
                  width="300px"
                  alt="SSOV"
                  margin="0 auto"
                />
              </Box>
            </Box>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

CommunityProjects.propTypes = {};

export default CommunityProjects;
